import React, { useEffect, useState } from 'react';
import FormControlLabel from '@mui/material/FormControlLabel';
import Grid from '@mui/material/Grid';
import IconButton from '@mui/material/IconButton';
import MenuItem from '@mui/material/MenuItem';
import Checkbox from '@mui/material/Checkbox';
import TextField from '@mui/material/TextField';
import Tooltip from '@mui/material/Tooltip';

import ClearIcon from '@mui/icons-material/Clear';

import { LocalizationProvider, DatePicker } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import moment from 'moment';
import axios from 'axios';
import { useDataAuth } from '../../hooks/useDataAuth';

const toMoment = (value) => {
    if (!value) return null;
    const parsed = value instanceof Date ? moment(value) : moment(value, 'YYYY/MM/DD', true);
    if (parsed.isValid()) return parsed;
    const loose = moment(value);
    return loose.isValid() ? loose : null;
};

export const RenderFilts = ({ field, setFilters, deletefilter, initialValue = null }) => {
    const [filtDateInit, setFiltDateInit] = useState(() => toMoment(initialValue?.initDate)?.toDate() ?? null);
    const [filtDateEnd, setFiltDateEnd] = useState(() => toMoment(initialValue?.endDate)?.toDate() ?? null);

    const SetFilter = (val, ctrl) => {
        const newInit = ctrl === 'ID' ? val : filtDateInit;
        const newEnd = ctrl === 'ED' ? val : filtDateEnd;
        if (ctrl === 'ID') setFiltDateInit(val);
        if (ctrl === 'ED') setFiltDateEnd(val);
        const init = toMoment(newInit);
        const end = toMoment(newEnd);
        if (init && end) {
            setFilters({
                initDate: init.format('YYYY/MM/DD'),
                endDate: end.format('YYYY/MM/DD'),
                operator: 'BETWEEN',
                type: field.type
            }, field.id);
        }
        else
            deletefilter(field.id);
    };

    const Clear = () => {
        if (field.type === 'date') {
            setFiltDateInit(null);
            setFiltDateEnd(null);
            deletefilter(field.id);
            return;
        }
        setfirst({
            value: '',
            operator: getOperator(field.type),
            type: field.type
        });
    };

    const getOperator = (tp) => {
        if (tp === 'date') return 'BETWEEN';
        return '=';
    };

    const [first, setfirst] = useState({
        value: initialValue?.value ?? '',
        operator: initialValue?.operator || getOperator(field.type),
        type: field.type
    });

    const setFilter = (param, param2) => {
        setfirst(prev => ({
            ...prev, [param2]: param
        }));
    }

    useEffect(() => {
        if (field.type === 'date') return;
        const hasValue = first.value !== undefined && first.value !== null && String(first.value).length > 0;
        if (hasValue && first.operator)
            setFilters(first, field.id);
        else
            deletefilter(field.id);
    }, [first.value, first.operator, field.type])


    const renderStringFilter = () => (
        <>
            <Grid size={{ xs: 12, sm: 2 }}>{field.label}</Grid>
            <Grid size={{ xs: 12, md: 4 }}>
                <TextField
                    select
                    label="Operador"
                    variant="outlined"
                    value={first.operator}
                    onChange={(e) => setFilter(e.target.value, 'operator')}
                    size="small"
                    fullWidth
                >
                    <MenuItem value="LIKE">Contiene</MenuItem>
                    <MenuItem value="=">Es igual a</MenuItem>
                    <MenuItem value="<>">No es igual a</MenuItem>
                </TextField>
            </Grid>
            <Grid size={{ xs: 12, md: 4 }}>
                <TextField
                    label="Valor"
                    variant="outlined"
                    size="small"
                    InputLabelProps={{ shrink: true }}
                    fullWidth
                    value={first.value}
                    onChange={(e) => setFilter(e.target.value, 'value')}
                />
            </Grid>
        </>
    );

    const renderNumberFilter = () => (
        <>
            <Grid size={{ xs: 12, sm: 2 }}>{field.label}</Grid>
            <Grid size={{ xs: 12, md: 4 }}>
                <TextField
                    select
                    label="Operador"
                    variant="outlined"
                    value={first.operator}
                    onChange={(e) => setFilter(e.target.value, 'operator')}
                    size="small"
                    fullWidth
                >
                    <MenuItem value="=">Es igual a</MenuItem>
                    <MenuItem value=">=">Es mayor o igual a</MenuItem>
                    <MenuItem value="<=">Es menor o igual a</MenuItem>
                    <MenuItem value="<>">No es igual a</MenuItem>
                </TextField>
            </Grid>
            <Grid size={{ xs: 12, md: 4 }}>
                <TextField
                    label="Valor"
                    variant="outlined"
                    type="number"
                    size="small"
                    InputLabelProps={{ shrink: true }}
                    fullWidth
                    value={first.value}
                    onChange={(e) => setFilter(Number(e.target.value), 'value')}
                />
            </Grid>
        </>
    );

    const renderDateFilter = () => (
        <>
            <Grid size={{ xs: 12, sm: 2 }}>{field.label}</Grid>
            <LocalizationProvider dateAdapter={AdapterDateFns}>
                <Grid size={{ xs: 12, md: 4 }}>
                    <DatePicker
                        label="Fecha inicio"
                        maxDate={new Date()}
                        value={filtDateInit}
                        onChange={(val) => SetFilter(val, 'ID')}
                        format="dd/MM/yyyy"
                        slotProps={{ textField: { size: 'small', fullWidth: true, InputLabelProps: { shrink: true } } }}
                    />
                </Grid>
                <Grid size={{ xs: 12, md: 4 }}>
                    <DatePicker
                        label="Fecha fin"
                        maxDate={new Date()}
                        minDate={filtDateInit}
                        value={filtDateEnd}
                        onChange={(val) => SetFilter(val, 'ED')}
                        format="dd/MM/yyyy"
                        slotProps={{ textField: { size: 'small', fullWidth: true, InputLabelProps: { shrink: true } } }}
                    />
                </Grid>
            </LocalizationProvider>
        </>
    );

    const renderBooleanFilter = () => (
        <>
            <Grid size={{ xs: 12, sm: 2 }}>{field.label}</Grid>
            <Grid size={{ xs: 12, md: 4 }}>
                <FormControlLabel
                    control={
                        <Checkbox
                            checked={first.value === '1'}
                            onChange={() => setFilter('1', 'value')}
                        />
                    }
                    label="True"
                />
            </Grid>
            <Grid size={{ xs: 12, md: 4 }}>
                <FormControlLabel
                    control={
                        <Checkbox
                            checked={first.value === '0'}
                            onChange={() => setFilter('0', 'value')}
                        />
                    }
                    label="False"
                />
            </Grid>
        </>
    );

    //#region SELECT_TRIGGER
    const [{ userSession }] = useDataAuth();
    const [optionsByField, setoptionsByField] = useState([]);
    useEffect(() => {
        if (field.type !== 'select' || !field.trigger?.[0]) return;
        const fetchOptions = async () => {
            const optionsEntries = await Promise.all(
                (async (field) => {
                    const { url, method, bodyData } = field.trigger[0];
                    try {
                        const response = await axios({
                            method,
                            url,
                            headers: {
                                'Content-Type': 'application/json',
                                'Authorization': `Bearer ${userSession.token}`,
                            },
                            data: bodyData,
                        });

                        return [field.id, response.data];
                    } catch (error) {
                        console.error(`Error fetching options for ${field.id}`, error);
                        return [field.id, []];
                    }
                })
            );
            setoptionsByField(Object.fromEntries(optionsEntries));
        };
        fetchOptions();
    }, [userSession.token]);

    const renderSelectFilter = () => (
        <>
            <Grid size={{ xs: 12, sm: 2 }}>{field.label}</Grid>
            <Grid size={{ xs: 12, md: 4 }}>
                <TextField
                    select
                    label="Operador"
                    variant="outlined"
                    value={first.operator}
                    onChange={(e) => setFilter(e.target.value, 'operator')}
                    size="small"
                    fullWidth
                >
                    <MenuItem value="=">Es igual a</MenuItem>
                    <MenuItem value="<>">No es igual a</MenuItem>
                </TextField>
            </Grid>
            <Grid size={{ xs: 12, md: 4 }}>
                <TextField
                    id={field.id}
                    name={field.id}
                    select
                    label={field.label}
                    variant="outlined"
                    value={first.operator}
                    onChange={(e) => setFilter(e.target.value, 'value')}
                    required
                    size="small"
                    defaultValue="none"
                    placeholder="select an option"
                    SelectProps={{
                        MenuProps: { PaperProps: { style: { maxHeight: 200 } } }
                    }}
                >
                    {(optionsByField[field.id] || []).map((option) => (
                        <MenuItem
                            key={option.code}
                            value={option.code}
                            sx={{ fontWeight: 'bold' }}
                        >
                            {option.name}
                        </MenuItem>
                    ))}
                </TextField>
            </Grid>
        </>
    );
    //#endregion

    return (
        <>
            {field.type === 'string' && renderStringFilter()}
            {field.type === 'number' && renderNumberFilter()}
            {field.type === 'date' && renderDateFilter()}
            {field.type === 'select' && renderSelectFilter()}
            {field.type === 'boolean' && renderBooleanFilter()}
            <Grid size={{ xs: 12, sm: 2 }} container justifyContent="center" alignItems="center">
                <Tooltip title="Borrar">
                    <IconButton size="small" sx={{ p: 0 }} onClick={Clear}>
                        <ClearIcon color="error" />
                    </IconButton>
                </Tooltip>
            </Grid>
        </>
    );
};